import React from "react";
import { Menu, MenuItem } from "@mui/material";

interface AttachmentActionsMenuProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  type: "LINK" | "FILE";
  onClose: () => void;
  onView: () => void;
  onEdit?: () => void;
  onDownload?: () => void;
  onDelete: () => void;
  disableEdit?: boolean;
}

const AttachmentActionsMenu: React.FC<AttachmentActionsMenuProps> = ({
  open,
  anchorEl,
  type,
  onClose,
  onView,
  onEdit,
  onDownload,
  onDelete,
  disableEdit,
}) => {
  return (
    <Menu open={open} anchorEl={anchorEl} onClose={onClose}>
      <MenuItem
        onClick={() => {
          onView();
        }}
      >
        View
      </MenuItem>

      {/* {type === "LINK" && onEdit && (
        <MenuItem
          onClick={() => {
            onEdit();
          }}
          disabled={disableEdit}
        >
          Edit
        </MenuItem>
      )} */}

      {type === "FILE" && onDownload && (
        <MenuItem
          onClick={() => {
            onDownload();
          }}
        >
          Download
        </MenuItem>
      )}

      <MenuItem
        onClick={() => {
          onDelete();
        }}
        disabled={disableEdit}
      >
        Archive
      </MenuItem>
    </Menu>
  );
};

export default AttachmentActionsMenu;
